import {Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

interface IProps {
  quantity: number;
  optionName: string;
  optionPrice: number;
  currency: string;
}

export const OptionItem: FC<IProps> = ({quantity, optionName, optionPrice, currency}) => {
  return (
    <Text as="li" fontWeight="500" fontSize="14px" lineHeight="17px" color={colors.textGray} mt={0}>
      {`${quantity} x ${optionName}`}
      {!!optionPrice && ` ${optionPrice} ${currency}`}
    </Text>
  );
};
